// @flow
import React from 'react';
import './style.less';
import {ItemBack} from 'modules/common/components/ItemBack';
import {GameText} from 'modules/common/components/GameText';

type TProps = {
    active?: boolean,
    children: any,
    className?: string,
    disabled?: boolean,
    icon?: boolean,
    onClick?: Function,
    round?: boolean,
    theme?: 'success' | 'danger' | 'warning' | 'blue' | 'lightBlue' | 'share-linkedln' | 'share-facebook' | 'share-vk' | 'share-twitter',
    wrapperClassName?: string,
};

function Button({children, icon, active, wrapperClassName, className, round, theme = 'success', ...rest}: TProps) {
    let fullClassName = `btn btn_theme-${theme}`;
    if (className) {
        fullClassName += ` ${className}`;
    }

    if (round) {
        fullClassName += ' btn_round';
    }

    if (active) {
        fullClassName += ' active';
    }

    if (icon) {
        fullClassName += ' btn_icon';
    }
    if (icon) {
        return (
            <ItemBack className={wrapperClassName} round={round}>
                <button className={fullClassName} {...rest}>
                    <span className="btn__inner">{children}</span>
                </button>
            </ItemBack>
        );
    }
    return (
        <ItemBack className={wrapperClassName} round={round}>
            <button className={fullClassName} {...rest}>
                <span className="btn__inner">
                    <GameText>{children}</GameText>
                </span>
            </button>
        </ItemBack>
    );
}

export {Button};
